import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hostIo = defineConnector({
  identifier: "hostIo",
  name: "Host.io",
  tagLine: "Website, company, and domain enrichment",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  defaultUrlPattern: () => "https://host\\.io/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Host.io](https://host.io/) and copy an API token from your account.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Host.io API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://host.io/api/full/github.com",
  },
});
